import { moderationReportConstants as mrc } from 'srcReact/ModerationReportPage'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { moderationReportService } from 'srcReact/services'
import { commonActions } from 'srcReact/components'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY

export const moderationReportActions = { getFlagReasons, getInfo, addFlag, flagAction, suspend, validate, reinstate, clearSuspendData }

function getFlagReasons() {
  return (dispatch) => {
    dispatch(request())

    moderationReportService.getFlagReasons().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mrc.GET_MODERATION_FLAG_REASONS_REQUEST, data }
  }
  function success(data) {
    return { type: mrc.GET_MODERATION_FLAG_REASONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: mrc.GET_MODERATION_FLAG_REASONS_FAILURE, error }
  }
}

function getInfo(id_organization, tab = '', filter = 'all', search = '', offset = 0, quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ id_organization, tab, filter, search, offset, quantity }))

    moderationReportService.getInfo(id_organization, tab, filter, search, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mrc.GET_MODERATION_INFO_REQUEST, data }
  }
  function success(data) {
    return { type: mrc.GET_MODERATION_INFO_SUCCESS, data }
  }
  function failure(error) {
    return { type: mrc.GET_MODERATION_INFO_FAILURE, error }
  }
}

function addFlag(id_post, object_type, object_id, id_organization, id_flag_reason, additional_justification = '') {
  return (dispatch) => {
    dispatch(request({ id_post, object_type, object_id, id_organization, id_flag_reason, additional_justification }))

    moderationReportService
      .addFlag(id_post, object_type, object_id, id_organization, id_flag_reason, additional_justification)
      .then(
        (response) => {
          dispatch(success(response))
          dispatch(commonActions.updateBannerData(response ? response.flag && response.flag.banner_data : null))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: mrc.ADD_FLAG_REQUEST, data }
  }
  function success(data) {
    return { type: mrc.ADD_FLAG_SUCCESS, data }
  }
  function failure(error) {
    return { type: mrc.ADD_FLAG_FAILURE, error }
  }
}

function flagAction(id_flagged_post, object_type, object_id, action) {
  return (dispatch) => {
    dispatch(request({ id_flagged_post, object_type, object_id, action }))

    moderationReportService.flagAction(id_flagged_post, object_type, object_id, action).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mrc.ACTION_FLAG_REQUEST, data }
  }
  function success(data) {
    return { type: mrc.ACTION_FLAG_SUCCESS, data }
  }
  function failure(error) {
    return { type: mrc.ACTION_FLAG_FAILURE, error }
  }
}

function suspend(moderationId, organizationId, message, object_id) {
  return (dispatch) => {
    dispatch(request({ moderationId, organizationId, message }))

    moderationReportService.suspend(moderationId, organizationId, message).then(
      (response) => {
        dispatch(success(response, object_id))
        dispatch(commonActions.updateBannerData(response ? response.action.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mrc.SUSPEND_REQUEST, response }
  }
  function success(response) {
    return { type: mrc.SUSPEND_SUCCESS, response, object_id }
  }
  function failure(error) {
    return { type: mrc.SUSPEND_FAILURE, error }
  }
}

function validate(moderationId, organizationId, object_id) {
  return (dispatch) => {
    dispatch(request({ moderationId, organizationId }))

    moderationReportService.validate(moderationId, organizationId).then(
      (response) => {
        dispatch(success(response, object_id))
        dispatch(commonActions.updateBannerData(response ? response.action.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mrc.VALIDATE_REQUEST, response }
  }
  function success(response, object_id) {
    return { type: mrc.VALIDATE_SUCCESS, response, object_id }
  }
  function failure(error) {
    return { type: mrc.VALIDATE_FAILURE, error }
  }
}


function reinstate(objectType, objectId) {
  return (dispatch) => {
    dispatch(request({ objectType, objectId }))

    moderationReportService.reinstate(objectType, objectId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mrc.REINSTATE_REQUEST, response }
  }
  function success(response) {
    return { type: mrc.REINSTATE_SUCCESS, response }
  }
  function failure(error) {
    return { type: mrc.REINSTATE_FAILURE, error }
  }
}

function clearSuspendData() {
  return { type: mrc.CLEAR_SUSPEND_DATA }
}

